/* file description */

import { RefListType } from '@/asset/AssetTask/templates/Cascade/type';
import { loadFreeJs } from '@/components/sp-business-btns/effect/useFreeJs';
import {
  BtnInfoType,
  OptionParams,
} from '@/components/sp-business-btns/sp-business-btns';
import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import { message } from 'antd';
import { useMemo } from 'react';
import _ from 'lodash';
import { useJsScript } from '@/asset/AssetTask/templates/Cascade/effect/useJsScript';

export interface FreeBtnClickProps {
  btnInfo: BtnInfoType;
  open: (val: OptionParams) => any;
  setButtonLoading: (val: boolean) => void;
}
interface UseFreeBtnClickProps {
  refList: RefListType;
}

export const useFreeBtnClick = ({
  refList,
}: UseFreeBtnClickProps) => {
  const { values, realoadValue, ...valueStore } = useValuesStore();
  const sotreState = useMetaStore((state) => state);

  const { utils } =
    sotreState;

  const validateModules = async () => {
    const promiseList = (Array.from(refList.current) as any[])?.map((itemRef) => {
      return itemRef[1].validateFields();
    });
    try {
      const result = await Promise.all(promiseList);
      return result;
    } catch (e) {
      console.error(e);
      message.error('请填写必选项');
      return null;
    }
  };

  const freeButtonClick = (
    { btnInfo, open, setButtonLoading }: FreeBtnClickProps,
    ctx = {},
    sp = {},
  ) => {
    const text = btnInfo?.freeJs;
    loadFreeJs(
      {
        open,
        setButtonLoading,
        buiNavigate: utils?.buiNavigate,
        reload: realoadValue,
        validateModules,
        setValues: valueStore.setValues,
        getValues: valueStore.getValues,
        ...sp,
      },
      {
        queryParams: utils?.queryParams,
        pageData: _.cloneDeep(values),
        btnInfo,
        refList,
        _window: window,
        ...sotreState,
        ...ctx,
      },
      text,
    );
  };
  useJsScript();
  return {
    freeButtonClick,
  };
};
